var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    _vm._g(
      {
        staticClass: "search-result-opportunity",
        class: _vm.classes,
        attrs: {
          "data-bot": _vm.context
            ? "search-result__opportunity--" + _vm.context
            : "search-result__opportunity",
          href: _vm.link
        },
        on: {
          mouseenter: _vm.handleMouseEnter,
          mouseleave: function($event) {
            _vm.isHovered = false
          }
        }
      },
      _vm.$listeners
    ),
    [
      _c("CompassObject", {
        attrs: { size: "extra-small", type: "object", object: "opportunity" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "search-result-opportunity__content" }, [
        _c("div", { staticClass: "search-result-opportunity__title" }, [
          _c("h5", {
            staticClass:
              "search-result-opportunity__name typographies-paragraph-medium-bold",
            domProps: { innerHTML: _vm._s(_vm.name) }
          }),
          _vm._v(" "),
          _vm.status
            ? _c(
                "div",
                { staticClass: "opportunity-status" },
                [
                  _c(
                    "CompassTag",
                    {
                      attrs: {
                        size: "small",
                        color: _vm.statusInformation.color,
                        icon: _vm.statusInformation.icon
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.status.label) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass:
              "search-result-opportunity__details typographies-paragraph-medium-regular"
          },
          [
            _c("li", { domProps: { innerHTML: _vm._s(_vm.ident) } }),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass:
                  "typographies-paragraph-medium-semibold search-result-opportunity__company"
              },
              [
                _c("CompassLink", {
                  attrs: { type: "secondary", link: _vm.relatedObject.url },
                  domProps: { innerHTML: _vm._s(_vm.relatedObject.name) }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("li", [_vm._v(_vm._s(_vm.amount))])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }